export class LatteTheme {
    actionColor?: string;
    actionInverseColor?: string;
    selectionColor?: string;
    hideCareerQuestionnaireLink?: boolean;
    hideContactQuestionnaireLink?: boolean;
    showSearchMenuLink?: boolean;
    primaryTextColor?: string;
}

export class EdsTheme {
    name?: string;
    themeJson?: NeoTheme;
    activationTime?: string;
    previewTime?: string | null;
    isDefault?: boolean;
    firstCreated?: string;
    lastUpdated?: string;
    version?: string | null;
}

export class NeoTheme {
    altText?: string;
    fontFamily?: string;
    logo?: string;
    primary?: string;
    primaryContainer?: string;
    primaryDark?: string;
    text?: string;
    hideCareerQuestionnaireLink?: boolean;
    hideContactQuestionnaireLink?: boolean;
    showSearchMenuLink?: boolean;
}
